/* Waxman's Gym Ratio Calculator Copyright (C) 2017 Waxman's Gym

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU General Public License for more details.

You should have received a copy of the GNU General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.*/

import React, { Component } from 'react';
import { formatNumber, isNumber } from '../helpers.js';

class BaseResults extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        if (this.props.show === false) {
            return null;
        }

        let resultsContent = '';
        if (!isNumber(this.props.results.snatch) || !isNumber(this.props.results.cnj)) {
            let missing = null;
            if (!isNumber(this.props.results.snatch) && !isNumber(this.props.results.cnj))
                missing = (<span><strong>Snatch</strong> or <strong>Clean & Jerk</strong></span>);
            else if (!isNumber(this.props.results.snatch) && isNumber(this.props.results.cnj))
                missing = (<strong>Snatch</strong>);
            else if (isNumber(this.props.results.snatch) && !isNumber(this.props.results.cnj))
                missing = (<strong>Clean & Jerk</strong>);
            resultsContent = <span>Você não inseriu um valor de {missing}, então não podemos fazer está analise</span>;
        }
        else {
            let snatchCJIdealRatio = 80;
            let snatchCJRatioTolerance = 2;
            let snatchCJRatio = this.props.results.snatch / this.props.results.cnj * 100;

            let diagnosis = '';
            let prescription = '';
            let description = '';

            // TODO: What should this message and tolerance be?
            if (Math.abs(snatchCJRatio - snatchCJIdealRatio) < snatchCJRatioTolerance) {
                resultsContent = (
                    <span>
                        A relação entre seu snatch e o Clean & Jerk demonstram um equilíbrio ideal. Continue
                        assim! Você pode continuar vendo a análise abaixo para ver como você pode melhorar
                        Em cada um dos movimentos.
                    </span>
                );
            }
            else {
                description = `O ideal é que seu Snatch seja em torno de ${formatNumber(snatchCJIdealRatio)}% do seu Clean & Jerk. Porém seu snatch está em ${formatNumber(snatchCJRatio)}% do seu Clean & Jerk.
                    Isso é uma diferença de ${formatNumber(snatchCJRatio - snatchCJIdealRatio)}%.`

                if (snatchCJRatio < snatchCJIdealRatio) {
                    diagnosis = "Comparando seu Snatch com seu Clean & Jerk, aparentemente você possui capacidade de fazer um snatch com mais carga. Isso pode significar que sua técnica de Snatch precisa ser melhorada.";

                    prescription = (
                        <span>
                            <p>
                                Embora exista uma série de
                                problemas técnicos que podem estar dificultando o seu Snatch,
                                é difícil dizer apenas a partir desses números qual aspecto de
                                sua técnica é o maior limitador.
                            </p>
                            <p>
                                Recomendamos que você avalie seus próprios movimentos em vídeo ou busque
                                um coach experiente para lhe ajudar a priorizar/consertar suas
                                ineficiências técnicas para que você possa aproveitar melhor sua
                                força. Veja também a análise específica de snatch
                                abaixo para obter dicas importantes.</p>

                        </span>);
                }
                else {
                    if (this.props.accessories.cnj['Front Squat'] !== undefined) {

                        let fsqRatio = this.props.accessories.cnj['Front Squat'].value / this.props.results.cnj * 100;
                        // let idealFsqRatio = this.props.accessories.cnj['Front Squat'].ratio;

                        if (fsqRatio > 125) {

                            diagnosis = `Com base nos números que você digitou, como o seu PR de Snatch e Clean & Jerk estão bem próximos do próximos
                            do ideal, e como você não tem nenhuma fraqueza aparente no front squat, isso significa que você tem
                            força para fazer um Clean & Jerk mais pesado. Assim, concluímos que sua técnica clean & jerk pode ser
                            melhorada.`;

                            prescription = (
                                <span>
                                    <p>
                                        Embora exista uma série de
                                        problemas técnicos que podem estar dificultando o seu Clean & Jerk,
                                        é difícil dizer apenas a partir desses números qual aspecto de
                                        sua técnica é o maior limitador.
                                    </p>
                                    <p>
                                        Recomendamos que você avalie seus próprios movimentos em vídeo ou busque
                                        um coach experiente para lhe ajudar a priorizar/consertar suas
                                        ineficiências técnicas para que você possa aproveitar melhor sua
                                        força. Veja também a análise específica de Clean
                                        abaixo para obter dicas importantes.
                                    </p>
                                </span>
                            );

                        }
                        else {
                            diagnosis = (
                                <span>
                                    <p>
                                        Com base nos números que você digitou, como o seu PR de Snatch e Clean & Jerk estão bem próximos do próximos
                                        do ideal, e como seu front squat mostra uma possibilidade de melhoria, nós suspeitamos que o seu
                                        Clean & Jerk está limitado por falta de força.
                                    </p>
                                </span>
                            );
                            prescription = (
                                <span>
                                    Você pode se beneficiar mais no seu Clean & Jerk melhorando sua força de front squat. Veja também a análise específica de Clean
                                    abaixo para obter dicas importantes.
                                </span>
                            );

                        }
                    }
                    else {
                        diagnosis = `Sua técnica de Clean & Jerk parece ineficiente comparado a carga que você consegue levantar no Snatch.`;
                        prescription = `Por favor insira um valor para o front squat para que possamos melhorar nossa análise`;
                    }
                }

                resultsContent = (
                    <span>
                        <h3>Diagnóstico</h3>
                        {diagnosis}

                        <h3>Prescrição</h3>
                        {prescription}

                        <h3>Como chegamos a esta conclusão?</h3>
                        {description}
                    </span>);
            }
        }

        return (
            <span>
                <div style={{ backgroundImage: `url(/img/prancheta_2.png)` }} className="panel panel-danger">
                    <div className="panel-heading">
                        {/* <h3 className="panel-title">Comparativo Snatch e Clean & Jerk</h3> */}
                        Comparativo Snatch e Clean & Jerk
                    </div>
                    <div className="panel-body" style={{ textAlign: 'left' }}>
                        {resultsContent}
                    </div>
                </div>
            </span>
        );
    }
}

export { BaseResults };
// vim: filetype=javascript.jsx



/** WEBPACK FOOTER **
 ** ./src/components/baseresults.js
 **/